import { IJobPost } from "./entities";
import { ISelectDropdownOption } from "./formElements";

export enum JobPortalTab {
    ACTIVE_JOBS = 'Active Jobs',
    ARCHIVED_JOBS = 'Archived Jobs',
    DRAFTS = 'Drafts',
    TOP_APPLICANTS = 'Top Applicants'
}

export enum JobPostDetailsTab {
    JOB_DETAILS = 'Job Details',
    APPLICATION_DETAILS = 'Application Details',
    AUDIENCE = 'Audience',
    APPLICANTS = 'Applicants',
}

export type TActiveJobField = "applicant_name" | "job_title" | "job_match" | "submission_date" | "resume" | "cover_letter";

export type TJobPostFormField = "location_id" | "title" | "occupation" | 'open_positions' | "description" | "status" | "industry_id" | "onsite_remote" | "employment_type" | "responsibilities" | "qualifications" | "job_level" | "salary_min" | "salary_max" | "salary_currency" | "salary_period" | "experience_level" | "keywords" | "advert_start" | "advert_end" | "job_start" | "require_cover_letter" | "contact_title" | "contact_email" | "web_link" | "associated_schools";
export type TRequiredJobPostFormField = "title" | "description" | "status";

export interface IJobPostFormData {
    id: number | null;
    location_id: { value: ISelectDropdownOption, error: string };
    title: { value: string, error: string };
    occupation: { value: ISelectDropdownOption, error: string };
    description: { value: string, error: string };
    open_positions: { value: string, error: string };
    industry_id: { value: ISelectDropdownOption, error: string };
    onsite_remote: { value: ISelectDropdownOption, error: string };
    employment_type: { value: ISelectDropdownOption, error: string };
    responsibilities: { value: string, error: string };
    qualifications: { value: string, error: string };
    job_level: { value: ISelectDropdownOption, error: string };
    salary_min: { value: string, error: string };
    salary_max: { value: string, error: string };
    salary_currency: { value: ISelectDropdownOption, error: string };
    salary_period: { value: ISelectDropdownOption, error: string };
    experience_level: { value: string, error: string };
    keywords: { value: string, error: string };
    advert_start: { value: string, error: string };
    advert_end: { value: string, error: string };
    job_start: { value: string, error: string };
    require_cover_letter: { value: ISelectDropdownOption, error: string };
    contact_title: { value: string, error: string };
    contact_email: { value: string, error: string };
    web_link: { value: string, error: string };
    associated_schools: { value: ISelectDropdownOption[], error: string };
}

export enum JobPostStatus {
    ACTIVE = 'active',
    ARCHIVED = 'archived',
    DRAFT = 'draft'
}

export enum OnsiteRemote {
    ON_SITE = 'onsite',
    REMOTE = 'remote',
    HYBRID = 'hybrid'
}

export enum EmploymentType {
    FULL_TIME = 'full-time',
    PART_TIME = 'part-time',
    CONTRACT = 'contract',
    VOLUNTEER = 'volunteer',
    TEMPORARY = 'temporary',
    INTERNSHIP = 'internship',
    CASUAL = 'casual',
    APPRENTICESHIP = 'apprenticeship',
    FREELANCE = 'freelance',
    CO_OP = 'co-op',
    SEASONAL = 'seasonal',
    LMIA = 'lmia',
    CASH = 'cash',
    GRADUATE_SCHEME = 'graduate-scheme',
    PLACEMENT = 'placement',
    OTHER = 'other'
}

export enum JobLevel {
    NEW_INTERN = 'new-intern',
    ENTRY = 'entry',
    MID = 'mid',
    SENIOR = 'senior',
    LEAD = 'lead',
    DIRECTOR = 'director'
}

export enum SalaryPeriod {
    FIXED_PRICE = 'fixed',
    HOURLY = 'hourly',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    BIWEEKLY = 'bi-weekly',
    MONTHLY = 'monthly',
    ANNUALLY = 'yearly'
}

export enum AttachedFileType {
    PDF = 'pdf',
    DOCX = 'docx',
}

export interface IJobPostList {
    id: number;
    job_title: string;
    posted_by: string | null;
    company: string | null;
    creation_date: Date;
    job_type: EmploymentType | null;
    job_views: number;
    applicants: number;
}

export interface IJobPostDetails extends IJobPost {
    job_views: number;
    applicants: number;
    posted_by: string | null;
}
